import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "@env/environment";
import {Survey, UpdateSurveyRequest} from "../../surveys.model";
import {SurveyService} from "../../survey.service";
import {Category, FormQuestionFilter, QuestionTemplate} from "@core/model/retailer/application-form.model";
import {Observable} from "rxjs";
import {
  ControlType,
  QuestionItem,
  TemplateComponent,
  templateComponents
} from "../../../application-form-builder/add-questions/question-components.model";
import {cloneDeep} from "lodash";

@Injectable({
  providedIn: 'root'
})
export class SurveyFormBuilderService {

  private _surveyService = inject(SurveyService);
  private _http = inject(HttpClient);

  constructor() {
  }

  get baseUrl(): string {
    return environment.apiRetailersHost + `/console/offering/district/pipeline/survey`;
  }

  get fileExtensions() {
    return {
      image: ['.jpg', '.png', '.jpeg'],
      document: ['.pdf', '.doc', '.docx', '.txt'],
      dataFile: ['.xls', '.xlsx', '.xlsm', '.csv']
    }
  }

  public updateFormTemplate(survey: UpdateSurveyRequest) {
    return this._surveyService.updateSurvey(survey);
  }

  public uploadFormFile(fileToUpload: File) {
    const formData = new FormData();
    formData.append('file', fileToUpload);
    return this._http.post(this.baseUrl + `/file-upload`, formData, {responseType: 'text'});
  }

  public downloadFormFile(fileId: string, questionFilter: FormQuestionFilter): Observable<ArrayBuffer> {
    const requestParams = new HttpParams()
      .set('filter', JSON.stringify(questionFilter));
    const options = {responseType: 'arraybuffer' as 'json', params: requestParams};
    return this._http.get<ArrayBuffer>(this.baseUrl + `/file-download/${fileId}`, options);
  }

  public getControlTemplate(questionTemplate: QuestionTemplate): TemplateComponent | null {
    let filtered: TemplateComponent[] = templateComponents.filter(template => template.controlType === questionTemplate.controlType);
    if (filtered.length > 0) {
      return filtered[0];
    }
    return null;
  }

  public isTypeHeading(item: QuestionItem) {
    return item.template.controlType == ControlType.HEADING
      || item.template.controlType == ControlType.HEADING_TEXT
      || item.template.controlType == ControlType.FORMATTED_TEXT
      || item.template.controlType == ControlType.INFO_FILE;
  }

  scoreByDefault(controlType: ControlType): boolean {
    const item = templateComponents.find(template => template.controlType === controlType);
    if (item) {
      return item.canScore;
    }
    return false;
  }

  public mapToUpdateSurveyRequest(survey: Survey, categories?: Category[]): UpdateSurveyRequest {
    return this._surveyService.mapToUpdateSurveyRequest(survey, categories);
  }

  //todo refactor to have preview-survey path
  //todo - move to form builder service in both survey smart form and survey questions components
  // public previewForm() {
  //   const locationOffering = this.contextService.getCurrentLocation()?.locationOfferings?.find(offering => offering.offeringUuid === this.offering?.offeringUuid)!;
  //
  //   const url = this.router.serializeUrl(this.router.createUrlTree([`/preview-apply/${this.formTemplate.code}`],
  //     {
  //       queryParams: {
  //         locationCode: locationOffering.locationCode!,
  //         offeringCode: locationOffering.offeringCode!,
  //         embedKey: locationOffering.embedKey!
  //       }
  //     }));
  //   window.open(url, '_blank');
  // }
}
